<script setup lang="ts">
import userStore from '@/store/UserStore.ts'
import { calculateDisplayPrice } from '@/helper/tools.ts'

defineProps<{
  price?: number
  label?: string
}>()
</script>

<template>
  <div class="total-price">
    <span class="h3 label">{{ label }}</span>
    <div class="h3 price">
      <b>{{ calculateDisplayPrice(price) }}</b><br>
      <span v-if="userStore.vatRate && userStore.enableDisplayOfVatPrices">{{
        $t('step_summary.table_vat_included', { vat: userStore.vatRate })
      }}</span>
      <span v-else>{{ $t('step_summary.table_vat_excluded') }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/style/helpers/include-media';

.total-price {
  margin-top: rem-calc(40);
  padding: rem-calc(32);
  color: white;
  display: flex;

  @include themify($themes) {
    background-color: themed('primaryColor');
  }

  .h2 {
    margin-bottom: 0;
  }

  @include media('<desktop') {
    padding: rem-calc(24);

    .h2 {
      font-size: rem-calc(20);
      line-height: rem-calc(25);
    }
  }

  .label {
    color: white;
    font-weight: bold;
  }

  .price {
    text-align: right;
    margin-left: auto;
    font-weight: normal;
    color: white;

    span {
      white-space: nowrap;
    }
  }

  &.card .h3 {
    font-size: rem-calc(24);
    line-height: rem-calc(30);
    margin-bottom: 0;
  }

  &.is--accessory {
    margin-top: 0;
    background-color: #fff;
    color: $textColor;
    padding: rem-calc(32) 0;

    @include media('<desktop') {
      padding: rem-calc(32) rem-calc(24);
    }

    @include media('<tablet') {
      padding: 1.5rem 1rem 1rem;
    }

    .h3 {
      margin-bottom: 0;
    }

    .label {
      color: $textColor;
    }

    .price {
      color: $textColor;
    }
  }
}
</style>
